export default function () {
  const videoWrappers = document.querySelectorAll('.video-with-bg');

  videoWrappers.forEach(wrapper => {
    const video = wrapper.querySelector('video');

    window.addEventListener("load", () => {
      video.load();

      if(!window.matchMedia(`(prefers-reduced-motion: reduce)`).matches) {
        video.play();
      }
    });
  });
}
